import styled from 'styled-components';

import { FormBase } from '@gbs-monorepo-packages/common';

export const SmallInputTextCustom = styled(FormBase.InputText)`
  width: unset;
`;
